/**
 * Projects module permission helpers (aligned with backend access/mutate checks).
 *
 * View, create, and edit all require ``manager || executive``.
 */

/**
 * Whether the user may open the Projects module (Home + Project page).
 *
 * @param {Object|null|undefined} user - CoreContext current user.
 * @returns {boolean}
 */
export function canAccessProjects(user) {
  return Boolean(user?.manager || user?.executive);
}

/**
 * Whether the user may create or edit JobNumber-backed projects.
 *
 * @param {Object|null|undefined} user - CoreContext current user.
 * @returns {boolean}
 */
export function canManageProjects(user) {
  return Boolean(user?.manager || user?.executive);
}
